import React, { memo, forwardRef } from "react";
const SvgCapitalT = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.54 8.83c.267 0 .48.04.64.12.174.08.3.18.38.3.094.12.154.247.18.38.027.12.04.22.04.3 0 .08-.013.187-.04.32a.915.915 0 01-.18.36.888.888 0 01-.38.3c-.16.08-.373.12-.64.12h-3.28v10.72c0 .307-.047.553-.14.74a1.345 1.345 0 01-.34.42.814.814 0 01-.4.2c-.146.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.938.938 0 01-.42-.2 1.516 1.516 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V11.03h-3.28c-.267 0-.487-.04-.66-.12-.16-.08-.287-.18-.38-.3a1.07 1.07 0 01-.16-.36 1.718 1.718 0 01-.04-.32c0-.08.013-.18.04-.3.027-.133.08-.26.16-.38.094-.12.22-.22.38-.3.173-.08.393-.12.66-.12h9.08z"
      />
    </svg>
  );
});
SvgCapitalT.displayName = "SvgCapitalT";
const MemoForwardRef = memo(SvgCapitalT);
export default MemoForwardRef;
